export default __webpack_public_path__ + "static/media/play-right.d9e8ef59.svg";